import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const openSearch = document.getElementById('search-trigger');
  const openSearchMobile = document.getElementById('search-trigger--mobile');
  const closeSearch = document.getElementById('close-search');

  //ouverture de la fenetre
  if (openSearch) {
    openSearch.addEventListener('click', function () {
      $('#search-trigger').attr('aria-expanded', 'true');
      $('.search-container').addClass('search-open');
      $('.search-container').removeClass('search-close');
      setTimeout(function () {
        document.documentElement.classList.add('lockedPosition');
        $('#findstrSearchWindow').focus();
      }, 1000);
    });
  }

  if (openSearchMobile) {
    openSearchMobile.addEventListener('click', function () {
      $('#search-trigger--mobile').attr('aria-expanded', 'true');
      $('.search-container').addClass('search-open');
      $('.search-container').removeClass('search-close');
      setTimeout(function () {
        document.documentElement.classList.add('lockedPosition');
        $('#findstrSearchWindow').focus();
      }, 1000);
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', function () {
      $('.close-window').attr('aria-expanded', 'false');
      $('#search-trigger').attr('aria-expanded', 'false');
      $('.search-container').addClass('search-close');
      $('.search-container').removeClass('search-open');
      $('.accessibility-menu__toggle').focus();
      document.documentElement.classList.remove('lockedPosition');
    });
  }

  const inputBar = document.getElementById('findstrSearchBar');
  const resultsWrapperBar = document.querySelector(
    '.search-window__results-wrapper.results-wrapper-bar'
  );

  if (inputBar && resultsWrapperBar) {
    inputBar.addEventListener('input', () => {
      if (inputBar.value.trim() === '') {
        resultsWrapperBar.style.display = 'none';
      } else {
        resultsWrapperBar.style.display = 'block';
      }
    });
  }

  const inputWindow = document.getElementById('findstrSearchWindow');
  const resultsWrapperWindow = document.querySelector(
    '.search-window__results-wrapper.results-wrapper-window'
  );

  if (inputWindow && resultsWrapperWindow) {
    inputWindow.addEventListener('input', () => {
      if (inputWindow.value.trim() === '') {
        resultsWrapperWindow.style.display = 'none';
      } else {
        resultsWrapperWindow.style.display = 'block';
      }
    });
  }

  /* popular requests init search on click */
  const buttons = document.querySelectorAll('.findstr-search-request');

  if (0 < buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const searchWord = button.getAttribute('data-search-word');

        if (searchWord) {
          const baseUrl = `${window.location.protocol}//${window.location.host}/`;
          const queryParams = `?s=${encodeURIComponent(
            searchWord
          )}&findstr[page]=1`;

          // Redirectoin vers l'URL
          window.location.href = baseUrl + queryParams;
        }
      });
    });
  }

  //Do not display empty result on fisrt loading page
  const findstr = window.findstr || {};

  findstr.hooks.addFilter(
    'urlManagementDisabled',
    'disabledUrl',
    (disabled, group) => {
      if ('resultsearch' !== group) {
        return true;
      }
      return disabled;
    }
  );

  findstr.hooks.addFilter(
    'findstrEmptyResultsMessageOnInit',
    'findstr-search-overlay',
    function (setEmptyAlertOnInit, group) {
      if ('lapocatieresearch' === group) {
        return false;
      }
      return setEmptyAlertOnInit;
    }
  );

  const searchInput = document.getElementById('resultsearch_global-search');
  const resultSpan = document.getElementById('result-search-query');
  const noTermSpan = document.getElementById('result-search-no_term');
  const withTermSpan = document.getElementById('result-search-with_term');

  findstr.hooks.addAction(
    'searchResults',
    'displayQueryandCountResults',
    () => {
      if (withTermSpan && noTermSpan) {
        if (searchInput && searchInput.value !== '') {
          noTermSpan.style.display = 'none';
          withTermSpan.style.display = 'inline';
        } else {
          withTermSpan.style.display = 'none';
          noTermSpan.style.display = 'inline';
        }
      }
      if (resultSpan) {
        resultSpan.textContent = searchInput.value;
      }

      //result count
      const field = document.querySelector('.findstr-field-results-count');
      if (field) {
        const resulCount = field.querySelector('.findstr-results-count');

        if (resulCount) {
          // si on a pas de term recherche
          if (searchInput && searchInput.value === '') {
            resulCount.style.display = 'none';
          } else {
            resulCount.style.display = 'inline';
          }
        }
      }
    }
  );

  // Synchronsier avec l'input de recherche
  if (searchInput && resultSpan) {
    searchInput.addEventListener('input', (event) => {
      if (resultSpan) {
        if (withTermSpan) {
          resultSpan.style.display = 'inline';
        } else {
          resultSpan.style.display = 'none';
        }
      }
      resultSpan.textContent = event.target.value;
    });
  }

  findstr.hooks.addAction(
    'afterSearchResults',
    'micrositeSearch',
    (results, group) => {
      const formBar = document.getElementById('header-form');
      const formModal = document.getElementById('modal-form');
      if (formBar) {
        if ('lapocatieresearch-homeheader' === group) {
          let actionUrl = '';
          if (document.body.classList.contains('microsite-page')) {
            let micrositeHome = '';
            const micrositeHomeLink =
              document.querySelector('header').dataset.micrositeUrl;
            if (micrositeHomeLink) {
              micrositeHome = micrositeHomeLink;
            }
            actionUrl =
              micrositeHome +
              _x('recherche', 'action search form', 'vtx') +
              '/?findstr[q]=' +
              results.query +
              '&findstr[group]=resultsearch';
            formBar.setAttribute('action', actionUrl);
            formBar.addEventListener('submit', function (e) {
              e.preventDefault();
              const actionURL = formBar.getAttribute('action');
              window.location.href = actionURL;
            });
          } else {
            actionUrl = window.theme.home_url;
          }
        }
      }
      if (formModal) {
        if ('lapocatieresearch' === group) {
          let actionUrl = '';
          if (document.body.classList.contains('microsite-page')) {
            let micrositeHome = '';
            const micrositeHomeLink =
              document.querySelector('header').dataset.micrositeUrl;
            if (micrositeHomeLink) {
              micrositeHome = micrositeHomeLink;
            }
            actionUrl =
              micrositeHome +
              _x('recherche', 'action search form', 'vtx') +
              '/?findstr[q]=' +
              results.query +
              '&findstr[group]=resultsearch';
            formModal.setAttribute('action', actionUrl);
            formModal.addEventListener('submit', function (e) {
              e.preventDefault();
              const actionURL = formModal.getAttribute('action');
              window.location.href = actionURL;
            });
          } else {
            actionUrl = window.theme.home_url;
          }
        }
      }
    }
  );
});
